import { add, qs, qsa, remove, contains } from "@fluorescent/dom";

const selectors = {
  mediaBy: id => `[data-media-item-id="${id}"]`,
  mediaWrapper: "[data-product-media-wrapper]",
  inYourSpace: "[data-in-your-space]",
  videoHasntAutoplayed: "video:not([data-has-autoplayed=\"true\"])",
};

const classes = {
  hidden: "hidden",
};

export default function (container, imageId, inYourSpaceButton) {
  const newMedia = qs(
    `${selectors.mediaWrapper}${selectors.mediaBy(imageId)}`,
    container
  );

  const otherMedia = qsa(
    `${selectors.mediaWrapper}:not(${selectors.mediaBy(imageId)})`,
    container
  );

  remove(newMedia, classes.hidden);

  // Update view in space button
  if (inYourSpaceButton) {
    if (newMedia.dataset.mediaType === "model") {
      inYourSpaceButton.setAttribute(
        "data-shopify-model3d-id",
        newMedia.dataset.mediaItemId
      );
    }
  }

  otherMedia.forEach(image => add(image, classes.hidden));

  // Autoplay any video that is shown, but only the first time
  const autoplayableVideo = qs(selectors.videoHasntAutoplayed, newMedia);
  if (
    autoplayableVideo &&
    !contains(document.documentElement, "prefers-reduced-motion")
  ) {
    autoplayableVideo.muted = true;
    autoplayableVideo.play();
    autoplayableVideo.setAttribute("data-has-autoplayed", true);
  }
}
